import { DiscountSuite } from "./discountTypes"
import { DbEntry } from "../types"

export const getDiscountGetAllUrl = () => `/.netlify/functions/discountGetAll`

export async function createDiscountSuite(
  suite: DiscountSuite,
  accessToken?: string
): Promise<DbEntry<DiscountSuite>> {
  try {
    const response = await fetch("/.netlify/functions/discountCreate", {
      method: "POST",
      body: JSON.stringify(suite),
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
    if (response.ok) return response.json()
    throw new Error("Could not CREATE discount!")
  } catch (err) {
    // @ts-ignore
    throw new Error(err)
  }
}

export async function updateDiscountSuite(
  id: string,
  updatedData: DiscountSuite,
  accessToken?: string
): Promise<DbEntry<DiscountSuite>> {
  try {
    const response = await fetch(
      `/.netlify/functions/discountUpdate?id=${id}`,
      {
        method: "PATCH",
        body: JSON.stringify(updatedData),
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    if (response.ok) return response.json()
    throw new Error("Could not UPDATE discount!")
  } catch (err) {
    // @ts-ignore
    throw new Error(err)
  }
}

export async function deleteDiscountSuite(
  id: string | any,
  accessToken?: string
) {
  try {
    const response = await fetch(
      `/.netlify/functions/discountDelete?id=${id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    if (response.ok) return
    throw new Error("Could not DELETE discount!")
  } catch (err) {
    // @ts-ignore
    throw new Error(err)
  }
}

export async function getDiscount(
  id: string,
  accessToken?: string
): Promise<DbEntry<DiscountSuite>> {
  try {
    const response = await fetch(`/.netlify/functions/discountGet?id=${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
    if (response.ok) return response.json()
    throw new Error("Could not GET discount!")
  } catch (err) {
    // @ts-ignore
    throw new Error(err)
  }
}

export const getOwnDiscountsUrl = () => `/.netlify/functions/discountGetOwn`
